// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"43":"app-theme-dark0","234":"app-theme-dark1","653":"app-theme-light0","844":"app-theme-light1"}[chunkId] + "." + {"43":"7e0bbd19","234":"e66ba298","653":"8afbd662","844":"a8fb6fd2"}[chunkId] + ".chunk.css";
};